import { BuildFontString } from "../utils/BuildFontString";
import { DetermineTextColor } from "../utils/DetermineTextColor";
import { Div2Floor } from "../utils/Div2Floor";
import { enumElementBorderStyle, enumElementDrawStates } from "../constants";
import { QStdButton } from "./QStdButton";
import { ThicknessAdjuster } from "../utils/ThicknessAdjuster";
import { Globals } from "./Globals";
import { SetCtxFont } from "../utils/SetCtxFont";

export class QFloatingBubbleButton extends QStdButton {
  constructor() {
    super();
    this.fName = "";
    this.fTruncName = "";
    this.fCurValue = null;
    this.fUseThemeColor = false;
  }

  InitButton(width, height, x, y, label, color, commandCode) {
    this.SizeElement(width, height);
    this.PositionElement(x, y);
    this.SetLabel(label);
    this.SetFontSize(Math.floor(height / 2));
    this.SetFillColor(color);
    this.SetHAlignment("center");
    this.SetCmdCode(commandCode);
    this.SetBorderRadius(Div2Floor(height + this.fMarginH));
    this.SetBorderStyle(enumElementBorderStyle.roundBorder);
    this.SetBorderColor(color);
    this.fTextColor = DetermineTextColor(color);
  }

  SetMaxWidth(maxWidth) {
    this.fMaxWidth = maxWidth;
  }

  UpdateFontSizeAndMargin(margin, fontSize) {
    this.fMarginH = margin;
    this.fFontSize = fontSize;
    this.AutoSize();
  }

  SetLabel(label) {
    this.fLabel = label;
    this.fTruncLabel = label;
  }

  DoCalculateMinWidth() {
    var ctx = this.fMeasureBuffer.getContext("2d");

    var fontInfo = BuildFontString(this.fFontName, this.fFontSize, this.fBold, false);
    SetCtxFont(ctx, fontInfo);
    var txt = this.fLabel;
    var txtDim = ctx.measureText(txt);
    var txtWidth = Math.ceil(txtDim.width);

    if (this.fMaxWidth != null && txtWidth > this.fMaxWidth) txtWidth = this.fMaxWidth;

    txtWidth = txtWidth + this.GetMarginH() * 2;
    return txtWidth;
  }

  DrawPad(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    ctx.save();
    ctx.lineWidth = 1;
    var sy = this.fVertOffset + 0.5;
    var ey = this.fVertOffset + this.fHeight - 0.5;
    var fill = this.fFillColor;
    //if (this.fCurDrawState === enumElementDrawStates.Hover)
    //{
    var offset = this.fCurDrawState === enumElementDrawStates.Hover ? 100 : 200;

    fill = ctx.createLinearGradient(0, sy - offset, 0, ey + 0); // this.fHeight
    fill.addColorStop(0, "#FFFFFF");
    fill.addColorStop(1, this.fFillColor);
    //}
    ctx.fillStyle =
      enumElementDrawStates.Disabled === this.fCurDrawState && !this.fUseThemeColor
        ? Globals._themeMode.button.disabled
        : fill;
    ctx.fill(this.fClippedRegion);
    ctx.globalAlpha = 1;
    ctx.restore();
  }

  DoRenderElement(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");

    var buttonFillStyle = this.fStdFillColor;
    var buttonStrokeStyle = "#F8F8F8";
    var txtFillStyle = this.fFontColor;
    txtFillStyle = this.fTextColor;
    var etchIt = false;

    // Draw the button (interior and border)
    var ds = this.GetDrawState();
    this.DrawPad(drawBuffer, ds);
    switch (ds) {
      case enumElementDrawStates.Std:
      case enumElementDrawStates.Hover:
      case enumElementDrawStates.MouseDown:
        break;
      case enumElementDrawStates.Disabled:
        txtFillStyle = Globals._themeMode.text.disabled;
        break;
    }

    ctx.fillStyle = buttonFillStyle;
    ctx.strokeStyle = buttonStrokeStyle;
    var thickness = 1;
    ctx.lineWidth = thickness;
    var adj = ThicknessAdjuster(thickness);
    var sx = this.fHorzOffset + adj;
    var sy = this.fVertOffset + adj;
    var sw = this.fWidth;
    var sh = this.fHeight;
    //if (this.GetDrawState() != enumElementDrawStates.Std)
    //	ctx.fillRect(sx,sy,sw,sh);
    //this.DrawButtonBorder(ctx,sx,sy,sw,sh,etchIt);

    // Now Draw the text in the button
    ctx.fillStyle = txtFillStyle;
    var fontInfo = BuildFontString(this.fFontName, this.fFontSize, this.fBold, false);
    //ctx.font= BuildFontString(this.fFontName, this.fFontSize, this.fBold, false);
    SetCtxFont(ctx, fontInfo);

    var txt = this.GetTruncLabel(); // fTruncLabel;
    var alignment = this.GetHAlignment();

    var txtHOffset = this.GetMarginH();
    if (alignment == "center")
      txtHOffset = Div2Floor(this.fWidth); // Math.floor(this.fWidth/2);
    else if (alignment == "right") txtHOffset = this.fWidth - this.GetMarginH();

    var txtVOffset = Div2Floor(this.fHeight) + 1; // Math.floor(this.fHeight/2);
    ctx.textAlign = alignment;
    ctx.textBaseline = "middle";
    ctx.fillText(
      txt,
      this.fHorzOffset + txtHOffset,
      this.fVertOffset + txtVOffset,
      this.fWidth - this.fMarginH * 2
    );
    this.DrawAdornment(drawBuffer);
  }
}
